import { useStoreRoom } from "../useStoreRoom";
import { StoreWallInterface } from "../types/store";



export const getSectionMinHeight = (shelving: StoreWallInterface, sectionIndex: number): number => {
    const sections = shelving.sections;

    return (
        useStoreRoom.getState().height
        - Math.min(sections[sectionIndex].leftRackHeight, sections[sectionIndex].height)
        - shelving.offsetCeiling
    ) / 1000;
}
